import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import SeoArticle from "./components/SeoArticle";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL;
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Hipobuy Sheet Guide',
  url: siteUrl,
  logo: logoUrl,
  description: 'Independent spreadsheet-based shopping research resource with category guides, product comparisons, and safety tips.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Sheet Guide',
  url: siteUrl,
  description: 'The ultimate Hipobuy Sheet resource for spreadsheet shopping research, product comparison, and category navigation across 14 product categories.',
  inLanguage: 'en-US',
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema as unknown as Record<string, unknown>} />
      <JsonLd data={websiteSchema as unknown as Record<string, unknown>} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <SeoArticle />
      </main>
      <Footer />
    </>
  );
}